export const ResumeSGChargeConstant = {
    CATEGORY: "Counter Charge",
    TITLE: "SG Charge Update",
    SEARCH_CRITERIA: "Search Criteria",
    OPS_DATE_RANGE: 'Ops Date Range',
    OPS_DATE_FROM: 'Ops Date(From)',
    OPS_DATE_TO: 'Ops Date(To)',
    CONSORTIUM_CODE: 'Consortium Code',
    VOYAGE_CODE: "Voyage Code",
    VESSEL_CODE: "Vessel Code",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub-charge Type",
    STATE: "State",
    SEQ_NO: 'Seq. No.',
    BILL_TO_COMPANY: 'Bill-To Company',
    CHARGE_ON_COMPANY: 'Charge-On Company',
    SUB_CHARGE_TYPE2: 'Sub Charge Type',
    CONTAINER_NO: 'Container No.',
    OPS_DATE: 'Ops Date',
    ETD: 'ETD',
    VESSEL_NAME: 'Vessel Name',
    TARIFF_TYPE: 'Tariff Type',
    TARIFF_CODE: 'Tariff Code',
    QTY: 'Qty',
    UOM: 'Uom',
    CHARGEING_FROM_DATE_TIME: 'Charging From Date/Time',
    CHARGEING_TO_DATE_TIME: 'Charging To Date/Time',
    OPS_LINE: 'Ops Line',
    DATA_REFERENCE_TYPE: 'Data Reference Type',
}
